import { userStore } from '@/stores/userStore'

export function hasRole(roleArray: string[]): boolean {
    if(roleArray.length === 0) {
        return true
    }
    const store = userStore()
    if (!store || !store.roles.length) return false
    return store.roles.some((userRole:any) =>
        roleArray.includes(userRole.code.toLowerCase())
    )
}

export function hasPermissions(permissionArray: string[]): boolean {
    if(permissionArray.length === 0) {
        return true
    }
    const store = userStore()
    if (!store || !store.permissions.length) return false

    const userPermissions = new Set(
        store.permissions.map((p:any) =>
            `${p.type}.${p.name}`.toLowerCase()
        )
    )

    return permissionArray.every(permission =>
        userPermissions.has(permission.toLowerCase())
    )
}
